module.exports = __webpack_public_path__ + "img/00050.323fd597.webp";